import { ReactComponent as DataElementTopRightSquare } from '@/assets/svgs/arrow-top-right-on-square.svg';
import { ReactComponent as IconNext } from '@/assets/svgs/icon-next.svg';
import { ReactComponent as IconTrashBin } from '@/assets/svgs/icon-trash-bin.svg';
import { ReactComponent as IconOval } from '@/assets/svgs/Oval.svg';
import { ReactComponent as IconSuccess } from '@/assets/svgs/packaged-icon-ticked.svg';
import SplitFileType from '@/components/SplitFileType/index';
import classname from 'classnames';
import { uniqueId } from "lodash";
import { useState } from "react";

const PaginateAttachments= ({
	combineAttachments,
	attachments,
	requiredAttachments,
	handleDownloadSingleFile,
	showVerifyModal,
	setFile,
	showDelete = true
}) => {
	const [currentPage, setCurrentPage] = useState(1)
	const attachmentsPerPage = 7
	const totalPage = Math.ceil(combineAttachments.length / attachmentsPerPage)

	let startPage, endPage;
	if (currentPage <= 2) {
		startPage = 1;
		endPage = Math.min(3, totalPage);
	} else if (currentPage >= totalPage - 1) {
		startPage = Math.max(totalPage - 2, 1);
		endPage = totalPage;
	} else {
		startPage = currentPage - 1;
		endPage = Math.min(currentPage + 1, totalPage);
	}

	const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, i) => i + startPage);

	const prevClass = classname({
		'share-data-card__attachments__pagination__left__prev': true,
		'share-data-card__attachments__pagination__left__prev--disabled': currentPage === 1
		});

	const nextClass = classname({
		'share-data-card__attachments__pagination__right__next': true,
		'share-data-card__attachments__pagination__right__next--disabled': currentPage === totalPage
	});

	return (
		<>
			<div className="share-data-card__upload__content__rows">
				{combineAttachments
				.slice((currentPage - 1) * attachmentsPerPage, currentPage * attachmentsPerPage)
				.map((attachment) => {
					const id = uniqueId()
					const attachmentDataClassName = classname({
						"share-data-card__upload__content__row": true,
						"share-data-card__upload__content__row--match": attachments.some(att => att.path === attachment)
					})

					return (
						<div className={attachmentDataClassName} key={id}>
							{requiredAttachments.includes(attachment) && (
								<span className="share-data-card__upload__content__icon-success">
									<IconSuccess/>
								</span>
							)}
							<span>
								<SplitFileType text={attachment} maxWidth={requiredAttachments.includes(attachment) ? 180 : 200 } data-testid={`split-file-type-${attachment}`} />
							</span>

							{attachments.some(att => att.path === attachment) && (
								<span className='share-data-card__content__icons'>
									<DataElementTopRightSquare
									 	 data-testid={`download-button-${attachment}`}
										onMouseDown={(e)=> {
											e.stopPropagation();
											handleDownloadSingleFile(attachment)
										}}
									/>
									{showDelete && (
										<IconTrashBin
											data-testid={`delete-button-${attachment}`}
											onClick={()=> {
												showVerifyModal()
												setFile(attachment)
											}}
										/>
									)}
								</span>
							)}

						</div>
					)
				})}

			</div>
			{combineAttachments.length> 7 && (
				<div className="share-data-card__attachments__pagination">
					<div className="share-data-card__attachments__pagination__content">
						<div className="share-data-card__attachments__pagination__left">
							<div className={prevClass} data-testid="prev-button"
								onClick={() => {
									if (currentPage === 1) return
									setCurrentPage(currentPage - 1)
								}}>
								<IconNext />
							</div>
						</div>
						<div className="share-data-card__attachments__pagination__center">
						{pageNumbers.map((page) => {
							const id = uniqueId();
							return (
								<div key={id} className={`share-data-card__attachments__pagination__center__current-page ${currentPage === page ? 'share-data-card__attachments__pagination__center__current-page--disabled' : ''}`}>
									<IconOval
										data-testid={`page-number-${page}`}
										key={page}
										onClick={() => setCurrentPage(page)}
									/>
								</div>
							);
						})}
						</div>
						<div className="share-data-card__attachments__pagination__right">
							<div className={nextClass} data-testid="next-button"
								onClick={() => {
									if (currentPage === totalPage) return
									setCurrentPage(currentPage + 1)
								}}>
								<IconNext />
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default PaginateAttachments
